import React, { useState } from "react";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { FaBoxes, FaSave, FaTimes, FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";

const StockOutForm = ({ onBack }) => {
  const [formData, setFormData] = useState({
    item_id: "",
    quantity: "",
    reason: "",
    notes: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Stock Out Data:", formData);
    toast.success("Stock Out recorded successfully!");
    setFormData({ item_id: "", quantity: "", reason: "", notes: "" });
    if (onBack) onBack();
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Card className="border-0 shadow-sm">
      <Card.Header className="bg-warning text-white d-flex align-items-center">
        <FaBoxes className="me-2" />
        <h5 className="mb-0">Stock Out</h5>
        {onBack && (
          <Button
            variant="light"
            size="sm"
            className="ms-auto"
            onClick={onBack}
          >
            <FaArrowLeft className="me-1" />
            Back
          </Button>
        )}
      </Card.Header>
      <Card.Body className="p-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Item *</Form.Label>
                <Form.Select
                  value={formData.item_id}
                  onChange={(e) => handleChange('item_id', e.target.value)}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select Item</option>
                  <option value="1">Rice</option>
                  <option value="2">Chicken</option>
                  <option value="3">Vegetables</option>
                  <option value="4">Oil</option>
                  <option value="5">Spices</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Quantity *</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.quantity}
                  onChange={(e) => handleChange('quantity', e.target.value)}
                  required
                  className="form-control-lg"
                  placeholder="Enter quantity"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Reason *</Form.Label>
                <Form.Select
                  value={formData.reason}
                  onChange={(e) => handleChange('reason', e.target.value)}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select Reason</option>
                  <option value="Sale">Sale</option>
                  <option value="Wastage">Wastage</option>
                  <option value="Damaged">Damaged</option>
                  <option value="Transfer">Transfer</option>
                  <option value="Expired">Expired</option>
                  <option value="Return">Return</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Date</Form.Label>
                <Form.Control
                  type="date"
                  defaultValue={new Date().toISOString().split('T')[0]}
                  className="form-control-lg"
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={formData.notes}
              onChange={(e) => handleChange('notes', e.target.value)}
              placeholder="Enter any additional notes about the stock out..."
              className="form-control-lg"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-3">
            {onBack && (
              <Button 
                variant="outline-secondary" 
                size="lg"
                onClick={onBack}
              >
                <FaTimes className="me-1" />
                Cancel
              </Button>
            )}
            <Button 
              variant="warning" 
              type="submit" 
              size="lg"
              className="px-4"
            >
              <FaSave className="me-1" />
              Save Stock Out
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default StockOutForm;
